import Styled from 'styled-components';

export const BlurContainer = Styled.div`
div {
    height: 100%;
    width:100%;
    display:flex;
    justify-content:center;
    align-items:center;
}

.top-quantity {
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    color: #2c99ff;
    margin-bottom: 0px;
}

.top-paragraph {
    color: black;
    font-size: 14px;
    margin-bottom: 0px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    font-weight:500;
    padding: 5px;
}
.result-cards{
    width: auto;
    display: flex;
    border-radius: 8px;
    height: 100px;
    justify-content: center;
    padding: 10px;
    height: auto;
    // border: 1px solid #dae7fd;
}

.bold-text{
    font-size: 20px;
    font-weight: 600;
    color: #2c99ff;
}
`;
